import React from 'react';

import { CoursePauseRequestFilterChips } from 'features/courseResume';
import CourseTypeFilter from '../CourseTypeFilter';
import CurrentBatchFilter from '../CurrentBatchFilter';
import EmailFilter from '../EmailFilter';
import FilterDrawerHeader from '../FilterDrawerHeader';
import FromToBeResumedDateFilter from '../FromToBeResumedDateFilter';
import NewBatchFilter from '../NewBatchFilter';
import PauseDurationFilter from '../PauseDurationFilter';
import UntilToBeResumedDateFilter from '../UntilToBeResumedDateFilter';

function FilterDrawerContent() {
  return (
    <>
      <FilterDrawerHeader />
      <CoursePauseRequestFilterChips />
      <div className="m-t-m m-b-xs h3 bold dark">All Filters</div>
      <EmailFilter />
      <CurrentBatchFilter />
      <NewBatchFilter />
      <FromToBeResumedDateFilter />
      <UntilToBeResumedDateFilter />
      <div className="row">
        <PauseDurationFilter />
        <CourseTypeFilter />
      </div>
    </>
  );
}

export default FilterDrawerContent;
